import { userServices } from '@/services'
import { InputHelperText } from '@/shared/components/input-helper-text'
import { useAcceptInvitationUserMutation } from '@/store/services/user-invitation.service'
import { Button, Input, Typography } from '@material-tailwind/react'
import axios from 'axios'
import { useFormik } from 'formik'
import { useEffect } from 'react'
import { Navigate, useNavigate, useSearchParams } from 'react-router-dom'
import * as yup from 'yup'

const validationSchema = yup.object({
  password: yup.string().required('Contraseña requerida.').min(6, 'Contraseña debe contener al menos 6 caracteres'),
  password_confirmation: yup
    .string()
    .oneOf([yup.ref('password'), null], 'Las contraseñas deben coincidir.')
})

export const UserAcceptInvitation = () => {
  const [searchParams] = useSearchParams()
  const invitationToken = searchParams.get('token')
  const [acceptInvitationUser, { isSuccess }] = useAcceptInvitationUserMutation()
  const navigate = useNavigate()

  if (!invitationToken) {
    return <Navigate to='/sign_in' />
  }

  const onSubmit = (values) => {
    acceptInvitationUser(values)
  }

  useEffect(() => {
    if (isSuccess) {
      navigate('/sign_in')
    }
  }, [isSuccess])

  useEffect(() => {
    userServices.signOut()
  }, [])

  const { handleChange, values, errors, touched, handleSubmit } = useFormik({
    initialValues: {
      password: '',
      password_confirmation: '',
      invitation_token: invitationToken
    },
    validationSchema,
    onSubmit
  })

  return (
    <div className='w-full h-full max-w-lg p-4 flex items-center my-0 mx-auto flex-col justify-center gap-16'>
      <section className='flex gap-10 flex-col justify-center items-center'>
        <div className='grid gap-4'>
          <Typography variant='h4'>Finaliza la creación de tu cuenta APS</Typography>

          <Typography variant='h6' color='gray' className='font-normal'>
            Ingresa y confirma tu nueva contraseña para completar el registro y acceder a todas las funcionalidades de nuestra plataforma. La contraseña debe tener mínimo 6 caracteres.
          </Typography>
        </div>
      </section>
      <div className='w-full flex flex-col gap-10'>
        <form onSubmit={handleSubmit} >
          <section className='flex flex-col gap-6'>
            <div>
              <Input
                name='password'
                label='Escribe tu nueva contraseña'
                type='password'
                onChange={handleChange}
                value={values.password}
                error={touched.password && errors.password}
              />
              {touched.password && errors.password && (
                <InputHelperText label={errors.password} color='red' />
              )}
            </div>

            <div>
              <Input
                name='password_confirmation'
                label='Repite tu nueva contraseña'
                type='password'
                onChange={handleChange}
                value={values.password_confirmation}
                error={touched.password_confirmation && errors.password_confirmation}
              />
              {touched.password_confirmation && errors.password_confirmation && (
                <InputHelperText label={errors.password_confirmation} color='red' />
              )}
            </div>
            <Button type='submit' size='lg'>
              Cambiar contraseña
            </Button>
          </section>
        </form>
      </div>
    </div>
  )
}
